@if (!isLoading && rewards.length > 0) {
  <div class="mb-7 w-full">
    <ul class="flex overflow-x-auto px-5 pt-2 pb-2 scrollbar-hide">
      @for (asset of rewards; track asset) {
        <li class="pr-3 flex-shrink-0 flex-grow-0 w-6/12 max-w-56">
          <ng-container *ngTemplateOutlet="assetCard; context: { asset }"></ng-container>
        </li>
      }
    </ul>
  </div>
}

@if (isLoading) {
  <div class="mb-7 flex overflow-x-auto px-5 pt-2 pb-2 scrollbar-hide">
    @for (i of [].constructor(30); track $index) {
      <div
        class="mr-3 flex-shrink-0 flex-grow-0 w-5/12 max-w-56 ng-star-inserted rounded-lg shadow-S overflow-hidden"
      >
        <div class="animate-pulse h-28 overflow-hidden relative bg-neutral-100"></div>
        <div class="h-32 p-4">
          <p class="animate-pulse mb-3 py-3 bg-neutral-100"></p>
          <p class="animate-pulse py-2 bg-neutral-100"></p>
        </div>
      </div>
    }
  </div>
}

<ng-template
  #assetCard
  let-asset="asset"
>
  <div class="h-full flex justify-between flex-col rounded-lg bg-white shadow-S overflow-hidden">
    @if (asset.picture_url) {
      <div
        class="flex-shrink-0 bg-neutral-50"
        style="aspect-ratio: 1"
      >
        <img
          [src]="asset.picture_url"
          class="object-contain"
          style="aspect-ratio: 1"
        />
      </div>
    }
    <div class="px-4 py-4 h-full text-sm flex flex-col justify-between">
      <div>
        <p class="text-base lg:text-md font-bold font-base leading-5 pt-1 mb-2">
          {{ asset.name }}
        </p>
        <p>{{ 'pongo.accessible-in-points' | translate: asset }}</p>
      </div>
    </div>
  </div>
</ng-template>
